/* * 声望排行榜 */
<template>
  <div class="rankView">
    <div class="header">声望排行榜</div>
    <div class="rankContainer">
      <div class="tabs">
        <span
          :class="`tab ${types === 'week' ? 'select' : ''}`"
          @click="rankTabClickEvent('week')"
          >周榜</span
        >
        <span
          :class="`tab ${types === 'month' ? 'select' : ''}`"
          @click="rankTabClickEvent('month')"
          >月榜</span
        >
        <span
          :class="`tab ${types === 'total' ? 'select' : ''}`"
          @click="rankTabClickEvent('total')"
          >总榜</span
        >
      </div>
      <div class="items">
        <div class="item" v-for="(item, index) in data" :key="index">
          <span class="name" @click="jumpToProfile(item)">{{item.owner && item.owner.name}}</span>
          <span class="segment" v-if="types === 'total'">[{{item.owner && item.owner.segment && item.owner.segment.name}}]</span>
          <img v-if="index === 0" class="icon" :src="images.gold" />
          <img v-else-if="index === 1" class="icon" :src="images.silver" />
          <img v-else-if="index === 2" class="icon" :src="images.bronze" />
          <span v-else class="number">{{ index + 1 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  IMG_MEDAL_GOLD,
  IMG_MEDAL_SILVER,
  IMG_MEDAL_BRONZE
} from '../assets';

import { types as RankTypes } from "../store/modules/rank";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "PopularityRank",
  data() {
    return {
      images:{
        gold: IMG_MEDAL_GOLD,
        silver: IMG_MEDAL_SILVER,
        bronze: IMG_MEDAL_BRONZE
      },  
      types: "week",
    };
  },
  computed: {
    ...mapState({
      data: state => state.rank.data
    })
  },
  methods: {
    ...mapActions({
      fetchData: RankTypes.FETCH_LIST_RANK
    }),

    // 人气排行榜，周榜、月榜、总榜点击事件
    rankTabClickEvent(type){
      this.types = type;
      this.fetchData(this.types);
    },
    //跳到个人主页
    jumpToProfile(item){
      let user_id = item.owner.user_id;
      this.$router.push(`/profile/${user_id}`);
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    this.fetchData(this.types);
  }
};
</script>

<style lang="less" scoped>
.rankView {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  .header {
    height: 35px;
    background-color: #ff7b00;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 35px;
  }
  .rankContainer {
    .tabs {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding-top: 10px;
      .tab {
        color: #666666;
        font-size: 15px;
        margin-left: 15px;
        margin-right: 15px;
        padding-bottom: 3px;
        cursor: pointer;
        &.select {
          color: #6b45e1;
          border-bottom: solid 1.5px #6b45e1;
        }
      }
    }
    .items {
      margin-bottom: 20px;
      margin-top: 10px;
      .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 40px;
        font-size: 14px;
        padding: 0 20px;
        .icon {
          width: 20px;
          margin-left: 20px;
        }
        .name {
          height: 40px;
          overflow: hidden;
          line-height: 40px;
          flex: 1;
          cursor: pointer;
          &:hover{
            color: #eb7350;
          }
        }
        .segment{
          color: #666666;
          font-size: 11px;
          margin-left: 20px;
        }
        .number {
          color: #5158ff;
          font-weight: bold;
          width: 20px;
          margin-left: 20px;
          text-align: center;
        }
      }
    }
  }
}
</style>
